var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar identicon",class:_vm.sizeClass,style:(_vm.identiconStyles)},[_vm._v("\n  "+_vm._s(_vm.identiconTitle)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57b01142","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/identicon.vue
// module id = null
// module chunks = 